import Api from './rest/PaymentApi';

export default new Api();
